import styled from 'styled-components';
import { Button } from '@simplywallst/ui-core';

export type StyleType = 'light' | 'dark';

interface Theme {
  styleType?: StyleType;
}

export const SearchOverlayWrapper = styled('section')<Theme>`
  overflow-y: hidden;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${({ theme, styleType }) =>
    styleType === 'light' ? theme.color.white : theme.color.charcoal};
  color: white;
  z-index: 9999;
  padding: 0 ${({ theme }) => theme.x2spacePx}px;
  padding-top: ${({ theme }) =>
    `calc(${theme.x2spacePx - 4}px + ${theme.safeAreaInsetTop})`};
`;

export const SearchFieldWrapper = styled.div`
  padding-right: ${({ theme }) => theme.x9spacePx}px;
`;

export const ScrollPane = styled('div')<Theme>`
  position: absolute;
  -webkit-overflow-scrolling: touch;
  top: ${({ theme }) =>
    `calc(${theme.x8spacePx - 1}px + ${theme.safeAreaInsetTop})`};
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  overflow-x: hidden;
  border-top: 1px solid
    ${({ theme, styleType }) =>
      styleType === 'light'
        ? theme.color.whiteRGBA(0.3)
        : theme.color.spaceGrayRGBA(0.1)};
`;

export const CancelWrapper = styled.div`
  position: absolute;
  width: ${({ theme }) => theme.x9spacePx}px;
  top: ${({ theme }) =>
    `calc(${theme.x2spacePx - 4}px + ${theme.safeAreaInsetTop})`};
  right: ${({ theme }) => theme.x1spacePx}px;
  padding-top: 2px;
`;

export const Cancel = styled(Button)`
  box-shadow: none;
  opacity: 0.5;
  &:focus,
  &:active,
  &:hover {
    box-shadow: none;
    background: none;
  }
`;
